import { isMobile } from 'react-device-detect';
import { DevicePlatform } from '../enums/shared.enums';

export enum OperatingSystem {
    ANDROID = 'android',
    IOS = 'ios',
    WINDOWS_PHONE = 'windows_phone',
    WINDOWS = 'windows',
    MACOS = 'macos',
    LINUX = 'linux',
    UNKNOWN = 'unknown',
}

function getOperatingSystem(): { name: OperatingSystem; version: string } {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.includes('android');
    const isIOS = ua.includes('iphone') || ua.includes('ipad');
    const isWindowsPhone = ua.includes('windows phone');
    const isWindows = ua.includes('windows') && !isWindowsPhone;
    const isMacOS = ua.includes('macintosh') || ua.includes('mac os x');
    const isLinux = ua.includes('linux') && !isAndroid;

    if (isAndroid) {
        const versionMatch = ua.match(/android\s([0-9.]+)/);
        return { name: OperatingSystem.ANDROID, version: versionMatch?.[1] || 'unknown' };
    } else if (isIOS) {
        const versionMatch = ua.match(/os\s([0-9_]+)/);
        return {
            name: OperatingSystem.IOS,
            version: versionMatch?.[1]?.replace('_', '.') || 'unknown',
        };
    } else if (isWindowsPhone) {
        return { name: OperatingSystem.WINDOWS_PHONE, version: 'unknown' };
    } else if (isWindows) {
        const versionMatch = ua.match(/windows nt\s([0-9.]+)/);
        return { name: OperatingSystem.WINDOWS, version: versionMatch?.[1] || 'unknown' };
    } else if (isMacOS) {
        const versionMatch = ua.match(/mac os x\s([0-9_]+)/);
        return {
            name: OperatingSystem.MACOS,
            version: versionMatch?.[1]?.replace('_', '.') || 'unknown',
        };
    } else if (isLinux) {
        return { name: OperatingSystem.LINUX, version: 'unknown' };
    }

    return { name: OperatingSystem.UNKNOWN, version: 'unknown' };
}

export default function useDeviceDetection(): {
    isMobile: boolean;
    platform: DevicePlatform;
    os: OperatingSystem;
    os_version: string;
} {
    const os = getOperatingSystem();

    return {
        isMobile,
        platform: isMobile ? DevicePlatform.WEB_MOBILE : DevicePlatform.WEB_DESKTOP,
        os: os.name,
        os_version: os.version,
    };
}
